"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkeletonCatalogueMobileRoot = void 0;
var _mui = require("@ori-ui/mui");
const SkeletonCatalogueMobileRoot = exports.SkeletonCatalogueMobileRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  margin: theme.spacing(3, 3, 1, 3)
}));
